import { render, staticRenderFns } from "./AccessoryRow.vue?vue&type=template&id=20d4a293&"
import script from "./AccessoryRow.vue?vue&type=script&lang=js&"
export * from "./AccessoryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports